var map = {
	"./algas-marinhas.jpg": 4046,
	"./aquarelaC.jpg": 92171,
	"./bg-algas-marinhas.png": 93852,
	"./bg-aquarela.png": 97808,
	"./bg-classico.png": 29753,
	"./bg-conchas-no-oceano.png": 63242,
	"./bg-floral-clean.png": 51265,
	"./bg-floral-ellegance.png": 33108,
	"./bg-floral-maritimo.png": 97137,
	"./bg-floral-night.png": 55908,
	"./bg-floral-rustic.png": 4898,
	"./bg-florani.png": 77131,
	"./bg-moderno.png": 30965,
	"./bg-pintura.png": 81786,
	"./bg-por-do-sol.png": 3473,
	"./bg-romantico.png": 57610,
	"./bg-rustico.png": 19099,
	"./classicoC.jpg": 26956,
	"./conchas-no-oceano.jpg": 11880,
	"./floral-clean.jpg": 40188,
	"./floral-ellegance.jpg": 81399,
	"./floral-maritimo.jpg": 31036,
	"./floral-night.jpg": 20360,
	"./floral-rustico.jpg": 83075,
	"./florani.png": 80265,
	"./modernoC.jpg": 44463,
	"./pinturaC.jpg": 76904,
	"./por-do-sol.jpg": 52992,
	"./romanticoC.jpg": 41875,
	"./rusticoC.jpg": 48864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25357;